/**
 * Created by Ning Jiang on 6/11/2019.
 */

import {Button, ButtonState} from "@nolimitcity/slot-game/bin/core/component/Button";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";

export class PickButton extends Button {

    private _glow:TimelineSprite;

    constructor(keyword:string, onClickedCallback:() => void) {
        super({
            idle : GameResources.getTextures(`${keyword}BannerIdle`),
            over : GameResources.getTextures(`${keyword}BannerIdle`)[0],
            down : GameResources.getTextures(`${keyword}BannerIdle`),
            disabled : GameResources.getTextures(`${keyword}BannerIdle`)[0],
        }, onClickedCallback, 15);

    }

    protected init():void {
        this._glow = new TimelineSprite(GameResources.getTextures("bannerGlow"), 6);
        this._glow.blendMode = PIXI.BLEND_MODES.ADD;
        this._glow.interactive = false;
        this._glow.anchor.set(0.5);
        this._glow.scale.set(2);
        this._glow.visible = false;
        this.addChildAt(this._glow, 0);

        super.init();


        this.interactiveChildren = false;
        this.hitArea = new PIXI.Rectangle(-140, -260, 280, 520);
    }

    public setState(state:ButtonState, autoPlay?:boolean):void {
        super.setState(state, autoPlay);

        this._glow.visible = false;
        this._glow.stopLoop();

        switch(state) {
            case ButtonState.over:
            case ButtonState.down:
                this.playGlow();
                break;
            default:
            // do nothing.
        }
    }

    public playGlow():void {
        this._glow.visible = true;
        this._glow.playLoop();
    }

    public playUnselectedTint():TweenLite {
        return TweenLite.to(this._disabledState, 0.2, {pixi : {tint : 0x555555}})
    }

    public resetUnselecteTime():void {
        this._disabledState.tint = 0xffffff;
    }
}